// 학생 화면 메뉴. name 이 그대로 /<name> 주소가 된다(HomePage.jsx 의 /:topTab).
// 과제를 푸는 /assignment, /preview, /review 와 이름이 겹치면 안 된다(student/CLAUDE.md).

// 홈(2026-11). 학년에 따라 초등 · 중고등 홈이 뜬다. 알림톡의 /home 링크도 여기로 온다
export const HOME_TAB = { name: "today", text: "오늘 과제" };
export const FINISHED_TAB = { name: "finished", text: "완료 과제" };
export const NOTICE_TAB = { name: "paper-assignment", text: "알림장" };

export const TAB_LIST = [HOME_TAB, FINISHED_TAB, NOTICE_TAB];

// 예전 '미완료 과제' 메뉴. 홈이 같은 목록을 보여 주므로 메뉴에서는 뺐지만 주소는 살려 둔다
export const UNFINISHED_TAB_NAME = "unfinished";

// 수학 학원 학생에게만 붙는 메뉴(2026-10-06 오답노트). 영어는 하지 않는다
export const WRONG_NOTE_TAB = { name: "wrong-note", text: "오답노트" };

// 포인트 상점. 상단 바 오른쪽의 포인트 · 스토어 단추로 들어온다(2026-10-04)
export const STORE_TAB_NAME = "store";

export const DEFAULT_TAB_NAME = HOME_TAB.name;

// 알림톡으로 이미 나간 링크가 /home?session=... 이라 그 주소도 계속 살아 있어야 한다.
// App.js 의 HomeRedirect 가 여기로 넘긴다.
export const DEFAULT_TAB_PATH = `/${DEFAULT_TAB_NAME}`;

// 세션은 쿼리스트링에 있으므로 메뉴를 옮길 때 그대로 들고 간다.
export const buildTabPath = (tabName, search) => `/${tabName}${search}`;
